// extracted by mini-css-extract-plugin
export var content = "_8z-3";
export var list = "_8z-4";
export var settingsContent = "_8z-7";
export var settingsPanel = "_8z-8";
export var state = "_8z-6";
export var triggerBadge = "_8z-2";
export var triggerButton = "_8z-1";
export var triggerShell = "_8z-0";
export var unreadDot = "_8z-5";